export const INITIAL_TABLE_INFINITE_SCROLL_STEP_NUMBER = 1;
export const TABLE_INFINITE_SCROLL_STEP_SIZE = 5;
export const Y_ZERO_COORDINATE = 0;
